import React, { useState, useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const LoadingSpinner: React.FC = () => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => {
        if (prev.length >= 10) {
          return '.';
        }
        return prev + '.';
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
      <CircularProgress />
      <Typography variant="body1" sx={{ minWidth: '120px', textAlign: 'center' }}>
        Loading{dots}
      </Typography>
    </Box>
  );
};

export default LoadingSpinner;
